<template>
     <b-button :id="`downloader-button`" variant="outline-primary" class="mr-1"
            @click="(!onExport && runDownload())" >
            <feather-icon
              icon="DownloadIcon"
              class="mr-50"
            />
            <span class="align-middle">{{ this.$t('Download') }}</span>
          </b-button>
</template>

<script>
import * as XLSX from 'xlsx'
import advancedFieldMgmt from '@/services/advancedFieldMgmt'

export default {
  props: {
    exportName: {
      type: String,
      required: true,
    },
    columns: {
      type: Object,
      required: true,
    },
    fullLoad: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      onExport: false,
    }
  },
    mounted() {
      this.onInitial()
    },
    methods: {
       toCamelCase(fieldId) {
        return fieldId
          .replace(/[\p{P}\p{S}\s_]+(\p{L})/gu, (_, chr) => chr.toUpperCase())
      },
      async runDownload() {
        const fullItemsRes = await advancedFieldMgmt.getDataFeed(this.fullLoad.fullQuery, this.fullLoad.schemaKey, this.fullLoad.tableKey)
        const fullItems = fullItemsRes.data.pageItems
        const fileName = this.exportName.concat('.xlsx')
        const jsonRaw = []
        const labelKeySorting = []
        const excelHeader = []
        this.columns.forEach((element, idx) => {
          labelKeySorting.push(this.toCamelCase(element.key))
          excelHeader.push(element.label)
        })
        fullItems.forEach((element, idx) => {
          const newItem = {}
          labelKeySorting.forEach(labelKey => {
            newItem[labelKey] = element[labelKey]
          })
          jsonRaw.push(newItem)
        })
        const worksheet = XLSX.utils.json_to_sheet(jsonRaw)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.sheet_add_aoa(worksheet, [excelHeader], { origin: 'A1' })
        XLSX.utils.book_append_sheet(workbook, worksheet, 'items')
        XLSX.writeFile(workbook, fileName, { compression: false })
      },
    },
}
  </script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
